import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("posturra_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Admin tier-impersonation (UI-only; bypass on credits still enforced server-side)
  const imp = localStorage.getItem("posturra_impersonate_tier");
  if (imp && imp !== "none") config.headers["X-Impersonate-Tier"] = imp;
  return config;
});

export const setImpersonateTier = (tier) => {
  if (!tier || tier === "none") localStorage.removeItem("posturra_impersonate_tier");
  else localStorage.setItem("posturra_impersonate_tier", tier);
};

export const getImpersonateTier = () => localStorage.getItem("posturra_impersonate_tier") || "none";

export const setToken = (t) => {
  if (t) localStorage.setItem("posturra_token", t);
  else localStorage.removeItem("posturra_token");
};

export const getToken = () => localStorage.getItem("posturra_token");
